import { Stack } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { FMFiltersProps } from "../../types";
import SearchBox from "../../../../core-components/theme/components/Searchbox/Searchbox";
import { Neutrals } from "../../../../core-components/theme/color-palette/colors";

const FMFilters = ({handleSearch, children, stackSxProps={}, searchBoxSxProps={}}: FMFiltersProps) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" sx={{...stackSxProps}} rowGap={6} columnGap={6}>
      <SearchBox
        placeholder={t('fileManager.searchDocuments', 'Search Documents')}
        sx={{
          height: '52px',
          borderColor: Neutrals[500],
          borderRadius: '4px',
          flex: 1,
          ...searchBoxSxProps
        }}
        onSearch={(value: string) => handleSearch(value)}
        onClear={() => handleSearch('')}
        fullWidth={true}
      />
      {
        children && <>{children}</>
      }
    </Stack>
  )
}

export default FMFilters;